import { appStorage } from './betaStorage'
export type LeoHomeModule = { id: string; label: string }

const KEY = 'schub.leo.homePrefs.v1'

function loadAll(): Record<string,string[]> {
  try { return JSON.parse(appStorage.getItem(KEY) || '{}') } catch { return {} }
}

export function loadLeoHomeModules(userId: string, defaults: string[]): string[] {
  const saved = loadAll()[userId]
  return Array.isArray(saved) ? saved : [...defaults]
}

export function saveLeoHomeModules(userId: string, ids: string[]) {
  const all = loadAll(); all[userId] = ids
  appStorage.setItem(KEY, JSON.stringify(all))
  window.dispatchEvent(new Event('schub-leo-home-prefs-updated'))
}

export function movedLeoHomeModules(userId: string, defaults: string[], modules: LeoHomeModule[]) {
  const home = new Set(loadLeoHomeModules(userId, defaults))
  return modules.filter((m) => !home.has(m.id))
}

